var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3234_33893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12.2409L0.5 13.5009L1.76 9.00087L10 0.800875C10.0931 0.705629 10.2044 0.62995 10.3271 0.578283C10.4499 0.526615 10.5818 0.5 10.715 0.5C10.8482 0.5 10.9801 0.526615 11.1029 0.578283C11.2256 0.62995 11.3369 0.705629 11.43 0.800875L13.2 2.58087C13.2937 2.67383 13.3681 2.78444 13.4189 2.90629C13.4697 3.02815 13.4958 3.15886 13.4958 3.29087C13.4958 3.42288 13.4697 3.55359 13.4189 3.67545C13.3681 3.79731 13.2937 3.90791 13.2 4.00087L5 12.2409Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3234_33893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg17);
export default __webpack_public_path__ + "static/media/svg17.596e6aca73d24bfe8b592b0c73884336.svg";
export { ForwardRef as ReactComponent };